import { AppHelper } from "../../appHelper.js";
import { AppBaseProps, CommonApp, Entity } from "../../core/components/commonApp.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { Helper } from "../../core/util/helper.js";
import React from "react";
export class AssignmentDistributionInput extends React.Component<AssignmentDistributionInputProps, any> {

    common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.init(this);
    }

    validate = () => {
        return new Promise<boolean>((resolve) => {
            let result: boolean = this.common.validate();
            if (new Date(this.props.entity.EndDate).getTime() < new Date(this.props.entity.StartDate).getTime()) {
                NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.DistributeAssignments.Input.StartDateLarger"));
                result = false;
            }
            resolve(result)
        })
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem, () => {
                this.props.onChange(this.props.entity);
                this.common.setEntityDirtyState(false);
            });
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return (<CommonApp {...props} />);
    }
}

export interface AssignmentDistributionInputProps extends AppBaseProps {
    onChange: (entity: AssignmentDistributionInputEntity) => void;
    entity: AssignmentDistributionInputEntity;
}

export interface AssignmentDistributionInputEntity extends Entity {
    StartDate: string | Date;
    EndDate: string | Date;
    ConsiderFlags: boolean;
    FlagId: string;
    GrNrs: number[];
    OGrNrs: number[];
    ActiveStrategy: string;
}